import React from 'react';
import PropTypes from 'prop-types';
import { LuLayoutGrid } from 'react-icons/lu';

import { ModuleCardButton, NewBadge } from '../styles';

// §5 do handoff: 30px, stroke 1.5 no card de módulo.
const ICON_SIZE = 30;
const ICON_STROKE = 1.5;

/**
 * Nível 1 da navegação faseada: card quadrado com ícone grande e o nome do
 * módulo. Sem contador, sem prévia de itens (§1.1) — o card só encaminha para
 * o modal do módulo.
 *
 * O card inteiro é o alvo de clique (§2.1) e é um `<button>` com
 * `aria-haspopup="dialog"` (§6).
 */
function ModuleCard({ module: mod, onOpen }) {
   const Icon = mod.icon || LuLayoutGrid;

   return (
      <ModuleCardButton
         type="button"
         onClick={() => onOpen(mod)}
         aria-haspopup="dialog"
         aria-expanded={false}
         title={mod.nome}
      >
         {mod.hasNew && <NewBadge>Novo</NewBadge>}

         <span className="module-icon" aria-hidden="true">
            <Icon size={ICON_SIZE} strokeWidth={ICON_STROKE} />
         </span>
         <span className="module-name">{mod.nome}</span>
      </ModuleCardButton>
   );
}

ModuleCard.propTypes = {
   module: PropTypes.shape({
      id: PropTypes.string.isRequired,
      nome: PropTypes.string.isRequired,
      icon: PropTypes.elementType,
      hasNew: PropTypes.bool,
   }).isRequired,
   onOpen: PropTypes.func.isRequired,
};

export default ModuleCard;
